/*
 * @Date: 2024-12-02 17:52:01
 * @Description:专区管理
 */

import ZoneMgmtList from '../views/zone-mgmt-list.vue';
import ZoneMgmtDetail from '../views/zone-mgmt-detail.vue';

export const route = [
  {
    path: '/main/industry/zone-mgmt',
    name: 'main-industry-zone-mgmt',
    redirect: '/main/industry/zone-mgmt/list',
    meta: {
      title: '专区管理',
      platFrom: 'industry'
    },
    children: [
      {
        path: '/main/industry/zone-mgmt/list',
        name: 'main-industry-zone-mgmt-list',
        meta: {
          title: '专区管理'
        },
        component: ZoneMgmtList
      },
      {
        path: '/main/industry/zone-mgmt/add',
        name: 'main-industry-zone-mgmt-add',
        meta: {
          parentPath: '/main/industry/zone-mgmt/list',
          title: '新增专区'
        },
        component: ZoneMgmtDetail
      },
      {
        path: '/main/industry/zone-mgmt/edit',
        name: 'main-industry-zone-mgmt-edit',
        meta: {
          parentPath: '/main/industry/zone-mgmt/list',
          title: '编辑专区'
        },
        component: ZoneMgmtDetail
      }
    ]
  },
  {
    path: '/main/asp/zone-mgmt',
    name: 'main-asp-zone-mgmt',
    redirect: '/main/asp/zone-mgmt/list',
    meta: {
      title: '专区管理',
      platFrom: 'asp'
    },
    children: [
      {
        path: '/main/asp/zone-mgmt/list',
        name: 'main-asp-zone-mgmt-list',
        meta: {
          title: '专区管理'
        },
        component: ZoneMgmtList
      },
      {
        path: '/main/asp/zone-mgmt/add',
        name: 'main-asp-zone-mgmt-add',
        meta: {
          parentPath: '/main/asp/zone-mgmt/list',
          title: '新增专区'
        },
        component: ZoneMgmtDetail
      },
      {
        path: '/main/asp/zone-mgmt/edit',
        name: 'main-asp-zone-mgmt-edit',
        meta: {
          parentPath: '/main/asp/zone-mgmt/list',
          title: '编辑专区'
        },
        component: ZoneMgmtDetail
      }
    ]
  }
];
